<template>
  <ViewEntityContainer :entityName="entityName" :identifier="$route.params.typeId" :getMethod="getMachineTypeById"
    :refreshOnTimestamp="true" :notificationListeners="[srEventKey]" :notificationValidator="notificationValidator">
  </ViewEntityContainer>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import SRConst from "@/helpers/Constants/SignalRConstants.js";
import ViewEntityContainer from "@/views/pim/suppliers/ViewEntityContainer.vue";
import EntityNames from "@/helpers/Constants/EntityNames.js";

export default {
  name: "ViewMachineTypeContainer",
  components: {
    ViewEntityContainer,
  },
  mixins: [clientAPI],

  data() {
    return {
      entityName: EntityNames.MachineType
    };
  },

  methods: {
    notificationValidator(args, identifier) {
      return args && args.machineTypeId == identifier;
    },
  },

  computed: {
    srEventKey() {
      return SRConst.EventKeys.MachineTypeChange;
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped></style>